import { render, staticRenderFns } from "./ViewNewsDetail.vue?vue&type=template&id=79cebc5e"
import script from "./ViewNewsDetail.vue?vue&type=script&lang=js"
export * from "./ViewNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports